// Footer Script mainly to get proper padding

(function ($) {
	let menuMainNav = "#menu-main-nav";
	let dropdown = ".menu-item-has-children";
	let dropdownItems = "> .menu .menu-item";
	let activeClass = "is-activated";
	let mobileSlideMenu = ".mobile-slide-menu";
	let mobileMenuActive = "is-activated";

	let $menuMainNav = $(menuMainNav);
	let $mainHamburger = $(".mobile-menu-hamburger > .main-hamburger");
	let $mobileSlideMenu = $(mobileSlideMenu);
	let $mobileSlideClose = $(`${mobileSlideMenu} .close`);

	let transitionTime = 500;

	let mobileTabActive = false;

	function mobileSlideBodyAppend() {
		if ($mobileSlideMenu.length) {
			$mobileSlideMenu.appendTo("body");
		}
	}

	function focusFirstMenuItem() {
		if (!mobileTabActive) {
			$mobileSlideClose.focus(); // first menu item focused
			mobileTabActive = true;
		}
	}

	function windowHandleKeydown(event) {
		if ($mobileSlideMenu.hasClass(activeClass)) {
			switch (event.keyCode) {
				// Enter
				case 27:
					mobileMenuToggle();
					break;
				// Tab
				case 9:
					focusFirstMenuItem();
					break;
			}
		}
	}

	function mobileMenuToggle() {
		if ($mobileSlideMenu.hasClass(mobileMenuActive)) {
			$mobileSlideMenu.removeClass(mobileMenuActive);
			setTimeout(function () {
				$mobileSlideMenu.css("display", "none");
			}, transitionTime + 50); // little extra for good measure
			mobileTabActive = false;
		} else {
			$mobileSlideMenu.css("display", "block");
			setTimeout(function () {
				$mobileSlideMenu.addClass(mobileMenuActive);
			}, 10);
		}
	}

	$(document).ready(function () {
		mobileSlideBodyAppend();

		$menuMainNav.find(dropdown).each(function () {
			let $dropdown = $(this);
			let $dropdownLink = $dropdown.find("> a");
			let $dropdownMenu = $dropdown.find("> .menu");

			let $dropdownItems = $dropdown.find(dropdownItems);
			let itemDelay = 0;
			$dropdownItems.each(function () {
				let $thisItem = $(this);
				$thisItem.css("transition-delay", `${itemDelay}ms`);
				itemDelay += 100;

				let $itemLink = $thisItem.find("a");
				$itemLink.addClass("is-child");

				$itemLink.on({
					focus: function () {
						$dropdownMenu.addClass(activeClass);
					},
					blur: function (event) {
						if (!$(event.relatedTarget).hasClass("is-child")) {
							$dropdownMenu.removeClass(activeClass);
						}
					},
				});
			});

			// Should only activate when interacting with the item
			$dropdownLink.on({
				focus: function () {
					$(this).closest(".has-dropdown").find(".menu").addClass(activeClass);
				},
				blur: function (event) {
					if (!$(event.relatedTarget).hasClass("is-child")) {
						$(this)
							.closest(".has-dropdown")
							.find(".menu")
							.removeClass(activeClass);
					}
				},
				mouseenter: function () {
					$(this).closest(".has-dropdown").find(".menu").addClass(activeClass);
				},
				mouseleave: function (event) {
					if (!$(this).hasClass(activeClass)) {
						let isTargetDropdown = $(event.relatedTarget).hasClass("menu-item");
						if (!isTargetDropdown && event.relatedTarget != "span") {
							$(this)
								.closest(".has-dropdown")
								.find(".menu")
								.removeClass(activeClass);
						}
					}
				},
			});

			$dropdownMenu.on({
				mouseleave: function () {
					$dropdownMenu.removeClass(activeClass);
				},
			});
		});

		$mainHamburger.on({
			click: function () {
				mobileMenuToggle();
			},
			keydown: function (event) {
				if (event.keyCode === 13) {
					mobileMenuToggle();
					$(this).blur();
				}
			},
		});

		$mobileSlideClose.on({
			click: function () {
				mobileMenuToggle();
			},
			keydown: function (event) {
				if (event.keyCode === 13) {
					mobileMenuToggle();
				}
			},
		});

		$(window).on("keydown", function (event) {
			windowHandleKeydown(event);
		});
	}); // document ready
})(jQuery);
